import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (error, info) {
    console.error(error)
    this.setState({ hasError: true })
  }

  render () {
    if (this.state.hasError) {
      return null
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object
}

export default ErrorBoundary



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.jsx